import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EnhancedDialog,
	EnhancedSnackbar,
	IResponse,
	IServerError,
	SingleColumnLayout,
	StandardPanel,
} from "@websential/cosmic-v20";
import { Box, Grid, Typography, useTheme } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import {
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../common/constants";
import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { sortDDLByLabel, useNavigateToLogout } from "../../common/Common";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { BankService } from "../../services/BankService";
import { BranchInfoSetupFieldsPanel } from "./Panels/BranchInfoSetupFieldsPanel";
import { BranchService } from "../../services/BranchService";
import { BranchSetupToolbar } from "./BranchSetupToolbar/BranchSetupToolbar";
import { BranchSetupValidationSchema } from "./validator";
import { DDLDataTable } from "../DDLDataTable";
import { EnhancedButtonPrimeReact } from "../EnhancedButtonPrimeReact";
import { IAppState } from "../../store/reducers";
import { IBranch } from "../../models/Branch/IBranch";
import { IGetListRequest } from "../../models";
import { VerifyBankDialogue } from "../VerifyBankDialogue";
import { setSelectedDrawerOptionsMenu } from "../../store/actions/drawerMenuOptionsActions";
import { setSelectedStickyNavBar } from "../../store/actions";
import { yupResolver } from "@hookform/resolvers/yup";

// import { SingleColumnLayout } from "../EmployeeAssignemnt/SingleColumnLayout";








export interface IBranchSetup { }
const SINGLE_RECORD_DATA_QUERY_KEY: any = "branch-single-data-record";
const BRANCH_LIST_DATA_QUERY_KEY: any = "branch-list";

const useGetData = (
	id: string | undefined,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, id, navigateToLogout],
		queryFn: () => {
			return BranchService.getById(id, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});

const useBranch = (
	params: IGetListRequest,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [BRANCH_LIST_DATA_QUERY_KEY, params],
		queryFn: (data) => {

			return BranchService.getBranch(params, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});

const useGetBankDDL = () =>
	useQuery({
		queryKey: ["bank-ddl"],
		queryFn: (data) => {
			return BankService.getGetBankDDL();
		},
		refetchOnWindowFocus: false,
	});

export const BranchSetup: React.FC<IBranchSetup> = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const theme = useTheme();
	const subMenuVisibility = useSelector(
		(state: IAppState) => state.drawerAction.subMenuVisibility
	);
	const navigateToLogout = useNavigateToLogout();
	const [openDialog, setDialogOpen] = useState(false);
	const [openArchiveDialog, setArchiveDialogOpen] = useState(false);
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [singleArchive, setSingleArchive] = useState<boolean>(false);
	const [branchId, setBranchId] = useState<number | string>(0);
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [isPendingData, setIsPendingData] = useState(false);
	const queryClient = useQueryClient();
	const { id } = useParams();

	const [editRecordId, setEditRecordId] = useState(id);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "branchTransitNo",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "branchTransitNo",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	const { isPending, data } = useBranch(queryParams, navigateToLogout);

	const branchList: any | null = data;

	const { isPending: isPendingBankDDL, data: bankDDL } = useGetBankDDL();


	const { isPending: isSubmitting, mutate: submitBranchFormFields } =
		useMutation({
			mutationFn: BranchService.create,
			onSuccess: (res: IBranch | IServerError | IResponse | any) => {

				if (res.status === 200) {
					// if (instanceOfIBranchResponse(res)) {
					// setEditRecordId(res.id);
					// queryClient.invalidateQueries(SINGLE_RECORD_DATA_QUERY_KEY);
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					let path = `/branch/${res.data.id}`;
					navigate(path);
					return Promise.all([
						queryClient.invalidateQueries({
							queryKey: [BRANCH_LIST_DATA_QUERY_KEY],
						}),
						queryClient.invalidateQueries({
							queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
						}),
					]);
				} else if (res.status === 201) {
					// if (instanceOfIBranchResponse(res)) {
					// setEditRecordId(res.id);
					// queryClient.invalidateQueries(SINGLE_RECORD_DATA_QUERY_KEY);
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					let path = `/branch/${res.data.id}`;
					navigate(path);
					setEditRecordId(res.data.id);
					return Promise.all([
						queryClient.invalidateQueries({
							queryKey: [BRANCH_LIST_DATA_QUERY_KEY],
						}),
						queryClient.invalidateQueries({
							queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
						}),
					]);
				} else {
					setSnackbarData({
						open: true,
						message: res.message ? res.message : "Something went wrong!",
						severity: "error",
					});
				}
			},
			onError: () => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});

	const { isPending: isPendingById, data: selectedDataRecord } = useGetData(
		editRecordId,
		navigateToLogout
	);

	const upadtedBranchListItems = useMemo(() => {
		return (
			branchList &&
			branchList.items &&
			branchList?.items.map((item: any) => ({
				...item,
				label: (
					<Link
						to={`/branch/${item.id}`}
						className="no-underline"
						style={{ color: theme.palette.primary.light }}
						onClick={() => setEditRecordId(item.id)}
					>
						{item.branchTransitNo}
					</Link>
				),
			}))
		);
	}, [branchList]);

	const DEFAULT_VALUES = {
		branchTransitNo: undefined,
		bankId: undefined,
		branchAddress: undefined

	};

	const formMethods = useForm<any>({
		resolver: yupResolver(BranchSetupValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
		defaultValues: DEFAULT_VALUES
	});

	const [openBranchAddedDialog, setOpenBranchAddedDialog] = useState(false);
	const [pendingValues, setPendingValues] = useState<any>(null);
	const onCloseBranchAddedHandler = () => {
		setOpenBranchAddedDialog(false)
	}
	const onConfirmBranchSubmit = () => {
		if (pendingValues) {
			setOpenBranchAddedDialog(false);
			setPendingValues(null);
			let payload = {
				id: id && id,
				navigateToLogout: navigateToLogout,
				branchTransitNo: pendingValues.branchTransitNo,
				bankId: pendingValues.bankId,
				branchAddress: pendingValues.branchAddress,
			};
			submitBranchFormFields(payload);
		}
	};

	const onSubmit = async (values: any) => {
		const selectedBank = bankDDL?.find((x: any) => x.value === values.bankId)
		try {
			setIsPendingData(true)
			const verifyBank = await BankService.bankOrBranchExists(selectedBank && selectedBank.bankCode, values.branchTransitNo);
			console.log("verifyBank", verifyBank)
			if (verifyBank && verifyBank.bankExist && verifyBank.branchExist) {
				let payload = {
					id: id && id,
					navigateToLogout: navigateToLogout,
					branchTransitNo: values.branchTransitNo,
					bankId: values.bankId,
					branchAddress: values.branchAddress,
				};
				submitBranchFormFields(payload);
			}
			if (verifyBank && !verifyBank.bankExist) {
				setSnackbarData({
					open: true,
					message: "Bank does not exist",
					severity: "error"
				})
			}
			if (verifyBank && verifyBank.bankExist && !verifyBank.branchExist) {
				setPendingValues(values);
				setOpenBranchAddedDialog(true);
			}

			setIsPendingData(false)
		}
		catch { setIsPendingData(false) }



	};

	useEffect(() => {
		if (id && selectedDataRecord) {

			Object.keys(selectedDataRecord).forEach((fieldName) => {
				const fieldValue = selectedDataRecord[fieldName];
				formMethods.setValue(fieldName, fieldValue ?? undefined);
			});
		}
	}, [id, selectedDataRecord]);

	const onSnackbarClosed = (
		_event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isDeleting, mutate: deleteBranchById } = useMutation({
		mutationFn: BranchService.delBranch,
		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {
				// remove the cache of the Branch fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			formMethods.reset();
			let path = `/branch`;
			navigate(path);
			return queryClient.invalidateQueries({
				queryKey: [BRANCH_LIST_DATA_QUERY_KEY],
			});
		},
		onError: () => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const deleteBranchField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let delPayload = {
				branchId: branchId,
				navigateToLogout: navigateToLogout,
			};
			deleteBranchById(delPayload);
			setDialogOpen(false);
		}
	};

	const onDeleteClicked = () => {
		setDialogOpen(true);
		setSingleDelete(true);
		if (selectedDataRecord) {
			setBranchId(selectedDataRecord.id);
		}
	};

	const onRowDeleteClicked = useCallback((params: any) => {
		setDialogOpen(true);
		setSingleDelete(true);
		setBranchId(params.id);
	}, []);

	const { isPending: isArchive, mutate: archiveBranchById } = useMutation({
		mutationFn: BranchService.archiveBranch,
		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {
				// remove the cache of the Branch fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			formMethods.reset();
			let path = `/branch`;
			navigate(path);
			return queryClient.invalidateQueries(BRANCH_LIST_DATA_QUERY_KEY);
		},
		onError: () => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const archiveBranchField = () => {
		if (singleArchive) {
			setSingleArchive(false);
			let ArchivePayload = {
				branchId: branchId,
				navigateToLogout: navigateToLogout,
			};
			archiveBranchById(ArchivePayload);
			setArchiveDialogOpen(false);
		}
	};

	const onArchiveClicked = () => {
		setArchiveDialogOpen(true);
		setSingleArchive(true);
		if (selectedDataRecord) {
			setBranchId(selectedDataRecord.id);
		}
	};

	const onCloseHandler = () => {
		setDialogOpen(false);
	};
	const onCloseArchiveHandler = () => {
		setArchiveDialogOpen(false);
	};

	const onResetClicked = () => {
		setSnackbarData({
			open: true,
			message: "Success",
			severity: "success",
		});
		formMethods.reset();
		let path = `/branch`;
		navigate(path);
	};

	// [Verify]
	const [openVerifyBankDialogue, setOpenverifyBankDialogue] = useState(false)

	const expandedLabels = ["Misc.", "Branch"];
	const expandedBranchSetupOrSetupItem = "Branch"; // Special case for "Setup" under "City Tax"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Misc." &&
				item.label === expandedBranchSetupOrSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedBranchSetupOrSetupItem && "/branch",
			};
			return enhancedItem;
		});
	};

	useEffect(() => {
		// dispatch(
		// 	setSelectedActivityLogActions({
		// 		entityId1: "",
		// 		entityId2: "",
		// 		entityId3: "",
		// 		screenName: ACCOUNTANT_SETUP_SCREEN_SLUG,
		// 		branchName: "",
		// 		activityType:
		// 			"activity_type=create&activity_type=updated&activity_type=delete",
		// 		activityLogVisibility: true,
		// 	})
		// );
		dispatch(setSelectedStickyNavBar({ isSticky: true }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	const onRowEditClicked = useCallback((params: IBranch | any) => {
		// alert(`Edit row with ID: ${params.row.id} has been clicked!`);
		let path = `/branch/${params.value}`;
		navigate(path);
	}, []);

	return (
		<Grid
		// sx={{
		// 	pb: "5rem",
		// 	"& .MuiAppBar-root": {
		// 		zIndex: 2,
		// 		top: subMenuVisibility ? "154px" : "112px",
		// 	},
		// }}
		>
			<BackdropCircularProgress
				open={isSubmitting || isPendingById || isDeleting || isArchive || isPendingData}
				testId="comapny Setup"
			/>
			<DeleteConfirmationDialog
				open={openDialog}
				deleteActionHandler={deleteBranchField}
				cancelActionHandler={onCloseHandler}
				testId="branch-confirmation-dialog"
			/>
			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
						<Grid size={{ xs: 12, sm: 12, md: 3.5, lg: 3.5, xl: 3.5 }}>
							<SingleColumnLayout
								children={
									<StandardPanel
										title="Branch"
										testId={`branch`}
										showTitle={false}
										variant="outlined"
										topPadding={2}
									>
										{/* [Verify] */}
										<BranchInfoSetupFieldsPanel bankDDL={bankDDL && sortDDLByLabel(bankDDL)} onVerifyBankClickedHandler={() => setOpenverifyBankDialogue(true)} />
									</StandardPanel>
								}
								toolbar={
									<BranchSetupToolbar
										onResetClicked={onResetClicked}
										onDeleteClicked={onDeleteClicked}
										isSubmitting={false}
										id={id}
									/>
								}
								toolbarPosition="bottom"
								showFullDiaplay={true}
								testId="form-layout"
							/>
						</Grid>
						<Grid size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}></Grid>
						<Grid
							size={{ xs: 12, sm: 12, md: 5.5, lg: 5.5, xl: 5.5 }}
							sx={{ marginTop: "16px" }}
						>
							<DDLDataTable
								rows={
									branchList && upadtedBranchListItems
										? upadtedBranchListItems
										: []
								}
								columns={[
									{ field: "label", headerName: "Branch No." },
									{ field: "bankName", headerName: "Bank Name" },
									{ field: "branchAddress", headerName: "Address" },
								]}
								showHeaderColumns={true}
								onRowEditClicked={onRowEditClicked}
								onRowDeleteClicked={onRowDeleteClicked}
								onRowArchiveClicked={onArchiveClicked}
								isLoading={isPending}
								totalRecords={
									branchList && branchList.total ? branchList.total : 0
								}
								initialPageSize={INITIAL_PAGE_SIZE}
								rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
								onRequestParamsChange={onRequestParamsChange}
								tableScrollHeight={"60vh"}
								selectedId={selectedDataRecord && id && selectedDataRecord.id}
							/>
						</Grid>
						<Grid size={{ xs: 0, sm: 0, md: 0, lg: 1, xl: 1 }}></Grid>
					</Grid>
				</form>
			</FormProvider>

			{/* Archive Dialogue */}
			<EnhancedDialog
				dialogTitle="Please Confirm"
				key="dialog-box"
				testId="dialog"
				onCloseHandler={onCloseArchiveHandler}
				open={openArchiveDialog}
				dialogContent={null}
				// showdividers={false}
				dialogAction={
					<Grid>
						<EnhancedButtonPrimeReact
							label="Cancel"
							severity="secondary"
							text
							raised
							onClickHandler={onCloseArchiveHandler}
							style={{ fontSize: "small" }}
						/>
						<EnhancedButtonPrimeReact
							label="Archive"
							severity="secondary"
							raised
							onClickHandler={() => archiveBranchField}
							style={{ marginLeft: "16px", fontSize: "small" }}
						/>
					</Grid>
				}
			/>
			{/* [Verify] */}
			<VerifyBankDialogue openVerifyBankDialogue={openVerifyBankDialogue} setOpenVerifyBankDialogue={(value: any) => setOpenverifyBankDialogue(value)} parentFormMethods={formMethods} />
			<EnhancedDialog
				dialogTitle="Please Confirm"
				key="dialog-box"
				testId="dialog"
				onCloseHandler={onCloseBranchAddedHandler}
				open={openBranchAddedDialog}
				dialogContent={
					<Box>
						<Typography variant="body2" sx={{ mb: 2 }}>
							Account 1 Branch / Transit No. is not a valid code as listed in our current banking records. If you believe this is correct, please mail us.
						</Typography>
						<Typography variant="body2">
							Note: Penalty amount will be deducted for providing incorrect bank details.
						</Typography>
					</Box>
				}
				showdividers={false}
				dialogAction={
					<Grid>
						<EnhancedButtonPrimeReact
							label="Cancel"
							severity="secondary"
							text
							raised
							onClickHandler={onCloseBranchAddedHandler}
							style={{ fontSize: "small" }}
						/>
						<EnhancedButtonPrimeReact
							label="Ok"
							severity="success"
							raised
							onClickHandler={onConfirmBranchSubmit}
							style={{ marginLeft: "16px", fontSize: "small" }}
						/>
					</Grid>
				}
			/>
			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"branch-snackbar"}
				open={snackbarData.open}
			/>
		</Grid>
	);
};
